module.exports = __webpack_public_path__ + "static/media/m1_sf_11.9bb18de8.png";